import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_table = _resolveComponent("q-table")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return _withDirectives((_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_card, {
      square: "",
      flat: "",
      bordered: "",
      class: "my-card bg-grey-1"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card_section, { style: {"padding":"0px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_table, {
              pagination: _ctx.pagination,
              "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pagination) = $event)),
              title: "Devices",
              rows: _ctx.filteredDevices,
              columns: _ctx.columns,
              "row-key": "name",
              dense: "",
              "binary-state-sort": "",
              "visible-columns": _ctx.visibleColumns,
              filter: _ctx.filter,
              "filter-method": _ctx.customFilter
            }, {
              "body-cell": _withCtx((props) => [
                _createVNode(_component_q_td, {
                  props: props,
                  onClick: ($event: any) => (_ctx.clickRow(props.row))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, _toDisplayString(props.value), 1)
                  ]),
                  _: 2
                }, 1032, ["props", "onClick"])
              ]),
              top: _withCtx(() => [
                _cache[3] || (_cache[3] = _createElementVNode("div", {
                  class: "col-2 q-table__title text-grey-brand text-bold",
                  style: {"width":"150px"}
                }, " Devices ", -1)),
                _createVNode(_component_q_space),
                _createVNode(_component_q_select, {
                  modelValue: _ctx.visibleColumns,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleColumns) = $event)),
                  multiple: "",
                  borderless: "",
                  dense: "",
                  "options-dense": "",
                  "emit-value": "",
                  "map-options": "",
                  "display-value": _ctx.$q.lang.table.columns,
                  options: _ctx.columns,
                  "option-value": "name",
                  style: {"min-width":"50px"}
                }, null, 8, ["modelValue", "display-value", "options"]),
                _createVNode(_component_q_input, {
                  modelValue: _ctx.filter,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
                  dense: "",
                  debounce: "300",
                  color: "primary"
                }, {
                  append: _withCtx(() => [
                    _createVNode(_component_q_icon, { name: "search" })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_q_btn, {
                  class: "q-ml-sm",
                  dense: "",
                  outline: !_ctx.deviceListOnlineOnly,
                  color: _ctx.deviceListOnlineOnly ? 'green' : 'grey',
                  icon: "wifi",
                  onClick: _ctx.toggleOnlineOnly
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.deviceListOnlineOnly
                  ? 'Showing online only'
                  : 'Showing all devices'), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["outline", "color", "onClick"])
              ]),
              _: 1
            }, 8, ["pagination", "rows", "columns", "visible-columns", "filter", "filter-method"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 512)), [
    [_vShow, _ctx.showDeviceTable]
  ])
}